
  const questionContainers = document.querySelectorAll(
    ".question_container"
  );

  questionContainers.forEach((accordionContainer) => {
    const accordionBtn = accordionContainer.querySelector(".accordion_button");
    const accordionContent = accordionContainer.querySelector(
      ".accordion__content"
    );
    
    accordionContent.style.height = accordionContent.scrollHeight + "px";

    accordionBtn.addEventListener("click", function () {
      this.parentElement.parentElement.classList.toggle("active");
      const content = this.nextElementSibling;
      console.log(1);
      if (accordionContent.classList.contains("open")) {
        accordionContent.classList.remove("open");
        accordionContent.classList.add("closed");
      } else {
        accordionContent.classList.remove("closed");
        accordionContent.classList.add("open");
        accordionContent.style.height = accordionContent.scrollHeight + "px";
      }
    });
  });


  const faqAccorodions = document.querySelectorAll(
    ".questions-block .question_container"
  );
  
  faqAccorodions.forEach((accordionContainer) => {
    const accordionBtn = accordionContainer.querySelector(".accordion_button");
    accordionBtn.addEventListener("click", function () {
      faqAccorodions.forEach((element) => {
        const accordionContent = element.querySelector(".accordion__content");
        if (element != accordionContainer) {
          element.querySelector(".accordion_button").parentElement.parentElement.classList.remove("active");
          if (accordionContent.classList.contains("open")) {
            accordionContent.classList.remove("open");
            accordionContent.classList.add("closed");
          }
        }
      });
    });
  });